import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StarBorderPurple500Icon(props: IconProps) {
    return <Icon {...props} iconKey={"star_border_purple500"}/>
}
